import React from "react";
import BootstrapTable from "react-bootstrap/Table";
import FireDetectionSensorIcon from "../../data/icons/화재/_THM_Mint.png";
import MotionSensorIcon from "../../data/icons/움직임/_THM_Mint.png";
import EmergencyBellIcon from "../../data/icons/비상벨/_THM_Mint.png";

const MarkerSensorListTable = ({
                                 propMarkerList,
                                 setMarkerList,
                                 propSetupFilter,
                                 onElemClick = null,
                                 showPopup = null,
                                 propAuth
                               }) => {

  const onClick = (e) => {
    const id = e.target.id;
    setMarkerList(
        propMarkerList.map((elem) => {
          return {
            ...elem,
            status: (elem.id === id) ? 'Mint' : 'Normal',
            selected: (elem.id === id) ? true : false
          }
        })
    )
  };

  const sourceDragEndHandler = (e) => {
    console.log(e.target.id);
    console.log(e);

    const id = e.target.id;
    setMarkerList(
        propMarkerList.map((elem) => {
          if (elem.id === id) {
            return {
              ...elem,
              x: 0,
              y: 0,
              setup_yn: 'Y',
              selected: true,
              status: 'Mint',
              isModified: true,
            }
          } else {
            return {
              ...elem,
              selected: false,
              status: 'Normal',
            }
          }
        })
    );
  };

  const getIcon = (name) => {
    let ret;
    if (name === 'Fire') {
      ret = FireDetectionSensorIcon;
    } else if (name === 'Motion') {
      ret = MotionSensorIcon;
    } else if (name === 'Bell') {
      ret = EmergencyBellIcon;
    }
    return ret;
  };


  return (
      <BootstrapTable hover className={"table repeater-table text-center"}>
        <thead className={"table-head text-secondary"}>
        <tr className={""}>
          <th className={"d-none"}>rpeat_no</th>
          <th className={"col"}>유형</th>
          <th className={"col"}>ID</th>
          <th className={"col"}>층</th>

          <th className={"col"}>중계기명</th>
          <th className={"col"}>실명</th>
          <th className={"col"}>모델</th>
          <th className={"col"}>FW버전</th>
          <th className={"col"}>동기상태</th>
        </tr>
        </thead>
        <tbody className={"table-body text-white"}>
        {
          Array.isArray(propMarkerList) ?
              (propMarkerList.map((elem, idx) => {
                if (elem.setup_yn === propSetupFilter) {
                  return (
                      <tr id={elem.id} key={idx} className={elem.selected == true ? 'table-secondary' : ''}>
                        <td className={"d-none"}>{elem.rpeat_no}</td>
                        <td>
                          {propSetupFilter === 'N' ?
                              <img
                                  src={getIcon(elem.type)}
                                  alt={elem.type}
                                  className={"icon align-middle me-1"}
                                  id={elem.sensor_no}
                                  onDragEnd={sourceDragEndHandler}
                                  draggable
                              /> :
                              <img
                                  src={getIcon(elem.type)}
                                  alt={elem.type}
                                  className={"icon align-middle me-1"}
                                  id={elem.sensor_no}
                                  onClick={onClick}
                              />
                          }
                        </td>
                        <td className={`${propAuth === "2" ? "column-title" : ''}`}
                            onClick={(e) => {
                              if (propAuth === "2") {
                                showPopup(e, elem.sensor_no);
                              }
                            }}
                        >{elem.sensor_id}</td>
                        <td>{elem.fclty_dtl_nm}</td>
                        <td>{elem.rpeat_lc_nm}</td>
                        <td>{elem.sensor_lc_nm}</td>
                        <td>{elem.modl}</td>
                        <td>{elem.fw_ver}</td>
                        <td>{elem.sync_yn_nm}</td>
                      </tr>)
                }
              })) : ''
        }
        </tbody>
      </BootstrapTable>
  );
}

export default MarkerSensorListTable;